// @vendors
const { md5 } = require('utilities/hash');

const findContractFromHash = options => {

    let accounts = null;
    let cards = null;

    if (options.accounts.toJS) {
        accounts = options.accounts.toJS();
    } else {
        accounts = options.accounts;
    }

    if (options.cards.toJS) {
        cards = options.cards.toJS();
    } else {
        cards = options.cards;
    }

    let contract = null;

    Object.keys(accounts).forEach(key => {
        let hash = md5(accounts[key].iban);
        if (options.hash === hash) {
            contract = accounts[key];
        }
    });

    Object.keys(cards).forEach(key => {
        let hash = md5(cards[key].number.toString().replace(/\s/g, ''));
        if (options.hash === hash && options.typeAccount === 1) {
            contract = cards[key];
        }
    });

    return contract;

}

module.exports = {
    md5,
    findContractFromHash,
}
